import Page from "../../../../components/Layout/Page";
import PageContent from "../../../../components/Layout/PageContent";
import T from "../../../../components/Typography";
import { useIsMobile } from "../../../../helpers/ui";
import {
  SectionFlexRow,
  SectionFlexColumn,
} from "../../../../components/General";
import { colors } from "../../../../styles";
import { Card } from "../Account/components";
import { useNavigate } from "react-router-dom";
import { useStoreActions } from "../../../../store";
import { DesktopHeader, MobileHeader } from "../Account/components";
import { SettingHeader, SettingsItem, SettingsSection } from "./components";
import { ReactComponent as ArrowRight } from "../../../../assets/fullarrowright.svg";
import { ReactComponent as CopyIcon } from "../../../../assets/icons/copy.svg";
import useGetAccount from "../../../../hooks/queries/employee/useGetAccount";
import { copyToClipboard } from "../../../../helpers/data";
import {
  employeeAccountStatementsPath,
  employeeLoginFullPath,
  employeeRequestCardPath,
} from "../../../../routes/paths";
import AuthService from "../../../../api/services/AuthService";
import { LinkConstants } from "../../../../helpers/links";
import {
  DebitCardConstants,
  hasDebitCard,
  showDebitCardFeature,
} from "../../../../helpers/debitcard";
import {
  ChangeAddressSetting,
  ChangePinSetting,
  DebitCardEnabledSetting,
  OrderNewCardSetting,
} from "../DebitCardInfo/components";

const Settings = () => {
  const { data } = useGetAccount();
  const livechatActions = useStoreActions((actions) => actions.livechat);
  const isMobile = useIsMobile();
  const navigate = useNavigate();
  return (
    <Page>
      {isMobile ? (
        <MobileHeader title="Profile & Settings" showBack showClose={false} />
      ) : (
        <DesktopHeader>
          <SectionFlexRow>
            <T variant="headingMd">Profile & Settings</T>
          </SectionFlexRow>
        </DesktopHeader>
      )}
      <PageContent
        customStyles={
          !isMobile ? { display: "flex", justifyContent: "center" } : undefined
        }
      >
        <SectionFlexColumn
          sx={
            !isMobile
              ? { width: "752px", maxWidth: "752px", minHeight: "342px" }
              : undefined
          }
        >
          <div
            style={{
              marginTop: isMobile ? "0" : "32px",
              paddingBottom: "64px",
            }}
          >
            {!isMobile && (
              <T variant="lgMed" color={colors.gray_600}>
                Account information
              </T>
            )}
            <Card hideStyleOnMobile>
              <SettingsSection>
                <SettingHeader title="General" />
                <SettingsItem
                  title="Change Name, Address, or Phone Number"
                  subtitle="Contact us via support chat"
                  rightSide={<ArrowRight />}
                  handleOnClick={() =>
                    livechatActions.setVisibility("maximized")
                  }
                  showBottomBottomBorder={false}
                />
              </SettingsSection>
              <SettingsSection>
                <SettingHeader title="TIFIN @Work Account" />
                {data && (
                  <SettingsItem
                    title="Account Number"
                    subtitle={data.challenger_saving.account_number}
                    rightSide={<CopyIcon />}
                    handleOnClick={() =>
                      copyToClipboard(data.challenger_saving.account_number)
                    }
                    showBottomBottomBorder={false}
                  />
                )}
                {data && (
                  <SettingsItem
                    title="Routing Number"
                    subtitle={data.challenger_saving.routing_number}
                    rightSide={<CopyIcon />}
                    handleOnClick={() =>
                      copyToClipboard(data.challenger_saving.routing_number)
                    }
                    showBottomBottomBorder
                  />
                )}
                <SettingsItem
                  title="Account Statements"
                  rightSide={<ArrowRight />}
                  handleOnClick={() => navigate(employeeAccountStatementsPath)}
                  showBottomBottomBorder={false}
                />
              </SettingsSection>
              {data &&
                showDebitCardFeature(data.challenger_saving.debit_card) && (
                  <SettingsSection>
                    <SettingHeader title="Debit Card" />
                    {!hasDebitCard(data.challenger_saving.debit_card) ? (
                      <SettingsItem
                        title="Request a Debit Card"
                        rightSide={<ArrowRight />}
                        handleOnClick={() => navigate(employeeRequestCardPath)}
                        showBottomBottomBorder={false}
                      />
                    ) : (
                      <>
                        <DebitCardEnabledSetting
                          data={data.challenger_saving.debit_card}
                        />
                        <SettingsItem
                          title="ATM Withdrawal Limit"
                          subtitle="$2,000 Per Month"
                          rightSide={
                            <T variant="mdReg" color={colors.gray_600}>
                              {DebitCardConstants.ATM_WITHDRAWAL_DAILY_LIMIT}
                            </T>
                          }
                        />
                        <SettingsItem
                          title="Card Spending Limit"
                          rightSide={
                            <T variant="mdReg" color={colors.gray_600}>
                              {DebitCardConstants.CARD_SPEND_DAILY_LIMIT}
                            </T>
                          }
                        />
                        <OrderNewCardSetting />
                        <ChangePinSetting
                          data={data.challenger_saving.debit_card}
                        />
                        <ChangeAddressSetting />
                      </>
                    )}
                  </SettingsSection>
                )}
              <SettingsSection>
                <SettingHeader title="Security" />
                <SettingsItem
                  title="Change Your Password"
                  rightSide={<ArrowRight />}
                  handleOnClick={() => {
                    window.open(LinkConstants.passwordReset, "_blank");
                  }}
                />
                <SettingsItem
                  title="Logout of TIFIN @Work"
                  rightSide={<ArrowRight />}
                  showBottomBottomBorder={false}
                  handleOnClick={() => {
                    AuthService.logout();
                    navigate(employeeLoginFullPath);
                  }}
                />
              </SettingsSection>
              <SettingsSection>
                <SettingHeader title="Additional Information" />
                <SettingsItem
                  title="Legal Disclosures"
                  subtitle="View our legal disclosures"
                  rightSide={<ArrowRight />}
                  handleOnClick={() => {
                    window.open(LinkConstants.disclosures, "_blank");
                  }}
                />
              </SettingsSection>
            </Card>
          </div>
        </SectionFlexColumn>
      </PageContent>
    </Page>
  );
};

export default Settings;
